const voucherDateAndTimeFormatter = (data, columnNames) => {
    return data.map(voucher => {
        let formattedVoucher = { ...voucher };

        columnNames.forEach(columnName => {
            if (voucher[columnName]) {
                // Parse the date string into a Date object
                const purchaseDate = new Date(voucher[columnName]);

                // Format the date as desired
                const formattedDate = purchaseDate.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    // hour: 'numeric',
                    // minute: 'numeric',
                    // hour12: true  // Use 12-hour format with AM/PM
                });

                // Update the voucher object with formatted date
                formattedVoucher[columnName] = formattedDate;  // Use bracket notation for dynamic property
            }
        });

        return formattedVoucher;
    });
}

export default voucherDateAndTimeFormatter;
